var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sequence-picker",style:(`
    ${_vm.width?`width: ${_vm.width};`:''}
    `)},[_c('div',{staticClass:"sequence-picker-header"},[_vm._t("header")],2),_c('div',{staticClass:"sequence-picker-sequence",style:(`${_vm.overflow_hidden ? 'flex-wrap: no-wrap; overflow: hidden;': 'flex-wrap: wrap'}`)},[_vm._t("sequence",null,{"prefix":_vm.prefix})],2),_c('div',{staticClass:"sequence-picker-subheader"},[_vm._t("subheader")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }